export enum VITTA_SUBSCRIPTION_PERMISSION {
  READ = 'vitta-subscription:read',
  WRITE = 'vitta-subscription:write',
}

export enum LEAD_INDICATION_LIST_FILTERS {
  SEARCH = 'q',
}

export enum LEAD_INDICATION_COLUMNS {
  REFERRING_COMPANY = 'referringCompanyName',
  CNPJ = 'referringCompanyCnpj',
  SENT_BY = 'sentBy',
  SENT_AT = 'sentAt',
}

export enum LEAD_INDICATION_LIST_ACTIONS {
  DETAILS = 'details',
}
